import { WASHMEN_CUSTOMER_API } from 'api/config';
import type GlobalTypes from 'api/types/global.types';

export async function fetchGlobalConfig() {
  const { data } = await WASHMEN_CUSTOMER_API.get<GlobalTypes.GlobalConfig>('/configurations');

  return data;
}
